export function formatPercent(value: number): string {
  return `${String(Math.round(value * 100))}%`
}

export function formatDegrees(value: number): string {
  return `${String(Math.round(value))}°`
}

export function formatSensitivity(value: number): string {
  return value.toFixed(1)
}
